import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavLink, NavSection } from '../shell/nav-menu';
import { SettingsMenuService } from './settings-menu.service';

/**
 * A settings page's heading (mockup settings .content-head): the scope pill,
 * the title and description, all taken from the page's Settings list entry (nav-menu.ts).
 * `url` defaults to the current URL.
 */
@Component({
    selector: 'app-settings-head',
    template: `
        <div class="sh" *ngIf="link">
            <!-- No "Group / Page" trail (mockup removed Settings breadcrumbs 2026-10-20); the scope stays. -->
            <div class="sh-context">
                <span class="sh-scope">{{link.scope === 'personal' ? 'Personal settings' : 'Organization settings'}}</span>
            </div>
            <h2>{{link.label}}</h2>
            <p *ngIf="link.description">{{link.description}}</p>
        </div>`,
    styles: [`
        .sh { padding-bottom: 22px; margin-bottom: 24px; border-bottom: 1px solid var(--im-line); }
        .sh h2 { margin: 0; color: var(--im-ink); font-size: 28px; font-weight: 800; letter-spacing: -.025em; }
        .sh p { max-width: 720px; margin: 7px 0 0; color: var(--im-muted); font-size: 14px; line-height: 1.5; }
        .sh-context { display: flex; flex-wrap: wrap; align-items: center; gap: 14px; margin-bottom: 14px; color: var(--im-muted); font-size: 13px; }
        .sh-scope { padding: 4px 10px; border: 1px solid var(--im-line); border-radius: 6px; color: var(--im-navy); background: #eef3f8; font-weight: 800; }
        :host-context(body.dark-mode) .sh-scope { background: #152238; }
        @media (max-width: 780px) { .sh h2 { font-size: 24px; } }
    `]
})
export class SettingsHeadComponent implements OnInit, OnChanges, OnDestroy {
    @Input() url: string;
    link: NavLink = null;
    group = '';
    private sections: NavSection[] = [];
    private subscription: Subscription;

    constructor(private menu: SettingsMenuService, private router: Router) { }

    ngOnInit() {
        this.subscription = this.menu.sections$.subscribe(sections => {
            this.sections = sections;
            this.refresh();
        });
    }

    ngOnChanges() {
        this.refresh();
    }

    private refresh() {
        const page = SettingsMenuService.find(this.sections, this.url || this.router.url);
        this.link = page ? page.link : null;
        this.group = page ? page.group : '';
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
